<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title>
                  Category Type : {{ category }}
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    color="primary"
                    @click="(addDialog = true), (edit = false), (name = '')"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-dialog v-model="addDialog" persistent max-width="600px">
                    <v-card>
                      <v-form v-model="formCategory" ref="formCategory">
                        <v-card-title>
                          <span v-if="edit == false" class="headline"
                            >Add Category Type</span
                          >
                          <span v-else class="headline"
                            >Edit Category Type</span
                          >
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                  v-model="name"
                                  outlined
                                  dense
                                  label="Category Type Name"
                                  required
                                ></v-text-field>
                              </v-col>

                              <!-- <v-col cols="12" sm="12" md="12">
                                <v-file-input
                                  v-model="categoryImg"
                                  @change="getFiles"
                                  label="Image"
                                  outlined
                                  dense
                                ></v-file-input>
                              </v-col> -->
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="red darken-1"
                            text
                            @click="addDialog = false"
                          >
                            Close
                          </v-btn>
                          <v-btn
                            v-if="edit == false"
                            color="blue darken-1"
                            text
                            :disabled="!formCategory"
                            @click="categoryadd()"
                          >
                            Save
                          </v-btn>
                          <v-btn
                            v-else
                            color="blue darken-1"
                            text
                            :disabled="!formCategory"
                            @click="categoryEdit()"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </v-card-title>
              </v-card>
              <v-card class="mb-4">
                <v-card-text
                  style="
                    padding: 0px !important;
                    padding-top: 10px !important;
                    height: 4em !important;
                  "
                >
                  <v-layout wrap style="align-items: center" justify-center>
                    <v-flex xs6 sm6 md6></v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-layout wrap justify-center>
                        <v-flex xs6 sm6 md4 text-right pt-2
                          >Items Per Page</v-flex
                        >
                        <v-flex xs6 sm6 md2>
                          <v-select
                            solo
                            flat
                            v-model="itemsPerPage"
                            :items="ItemsCount"
                            dense
                            required
                          ></v-select>
                        </v-flex>
                        <!-- <v-flex
                          xs6
                          sm6
                          md2
                          text-center
                          pt-2
                          style="color: black"
                        >
                          {{ pageStart }}-{{ pageEnd }} of {{ count }}
                        </v-flex> -->
                        <v-flex xs2 sm2 md1 pt-2 text-right>
                          <span v-if="page > 1">
                            <v-icon @click="prevpage" color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-center>
                          {{ page }}
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-left>
                          <span v-if="page < totalpages">
                            <v-icon @click="nextpage" color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-data-table
                  bordered
                  :headers="headers"
                  :items="subcategory"
                  hide-default-footer
                  :items-per-page="itemsPerPage"
                  class="row-pointer pb-12 tableValue"
                >
                  <!-- <template v-slot:item.icon="{ item }">
                    <img
                      v-bind:src="baseURL + '/file/get/' + item.icon"
                      width="auto"
                      height="25px"
                    />
                  </template> -->

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon color="primary" @click="editCategoryDialog(item)">
                      mdi-pencil
                    </v-icon>

                    <v-dialog v-model="item.deleteCategory" max-width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          color="red"
                          @click="deleteConfirmation(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>

                      <v-card>
                        <v-card-title class="headline grey lighten-2">
                          Delete Confirmation
                        </v-card-title>

                        <v-card-text>
                          <span style="font-size: 16px; font-weight: 600"
                            >Please confirm that you want to Remove this
                            Category Type?
                          </span>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn
                            color="primary"
                            @click="item.deleteCategory = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="error"
                            class="mr-4"
                            @click="DeleteCategory(item)"
                          >
                            Delete
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      headers: [
        // { text: "Icon", value: "icon", sortable: false },
        { text: "Category Type", value: "name" },
        // { text: "GST (slab1 in percentage)", value: "gstSlab1Percentage" },
        // { text: "GST (slab2 in percentage)", value: "gstSlab2Percentage" },
        // { text: "GST (slab2 minimum price)", value: "gstSlab2MinimumPrice" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      edit: false,
      editId: "",
      dialog: false,
      addDialog: false,
      editdialog: false,
      deleteCategory: false,
      formCategory: false,
      categoryImg: null,
      sbId: null,
      attachments: null,
      attachmentsformData: new FormData(),
      subcategory: [],
      category: "",
      editingitem: [],
      name: "",
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      itemsPerPage: 20,
      page: 1,
      totalpages: 0,
      ItemsCount: [20, 30, 50, 100],
      msg: "",
      showsnackbar: false,
      timeout: 3000,
    };
  },
  beforeMount() {
    this.getCategory();
    this.getcatType();
  },
  watch: {
    itemsPerPage: function () {
      this.getcatType();
    },
  },
  methods: {
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getcatType();
        // } else {
        //   this.page--;
        this.getcategory();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getcatType();
        // } else {
        //   this.page++;
        this.getcategory();
        // }
      }
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/category/view/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.category = response.data.data.name;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getcatType() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/categorytype/list/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          limit: this.itemsPerPage,
          page: this.page,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subcategory = response.data.data;
          this.count = response.data.totalLength;
          this.totalpages = Math.ceil(
            response.data.totalLength / this.itemsPerPage
          );

          if (response.data.length > 0) {
            this.pageStart = (response.data.page - 1) * response.data.limit + 1;
            this.pageEnd = this.pageStart + response.data.length - 1;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },

    categoryadd() {
      this.addDialog = false;
      var data = {};
      data["name"] = this.name;
      data["categoryId"] = this.$route.params.id;
      axios({
        url: "/categorytype/add",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.scId = response.data.scId;

            // if (this.categoryImg) {
            //   this.attachmentsformData.append("icon", this.attachments);
            //   this.uploadattachments();
            // } else {
            //   this.editId = null;
            //   this.getSubCategory();
            // }
            this.getcatType();
            this.msg = "SubCategory Added!";
            this.showsnackbar = true;
            this.name = null;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    deleteConfirmation() {
      this.deleteCategory = true;
    },
    DeleteCategory(item) {
      item.deleteCategory = false;

      axios({
        url: "/categorytype/delete/" + item._id,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Category Deleted";
            this.showsnackbar = true;

            this.getcatType();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    editCategoryDialog(item) {
      this.edit = true;
      this.addDialog = true;
      this.name = item.name;
      this.editId = item._id;
    },
    categoryEdit() {
      this.addDialog = false;
      var data = {};
      data["name"] = this.name;
      axios({
        url: "/categorytype/edit/" + this.editId,
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;
          this.edit = false;
          this.appLoading = false;
          if (response.data.status) {
            // if (this.categoryImg) {
            //   this.attachmentsformData.append("icon", this.attachments);
            //   this.uploadattachments();
            // } else {
            //   this.editId = null;
            //   this.getSubCategory();
            // }
            this.getcatType();
            this.msg = "Category Edited";
            this.showsnackbar = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getFiles() {
      var selectedFiles = this.categoryImg;
      if (this.categoryImg) {
        this.msg = null;
        this.attachments = selectedFiles;
      }
    },

    uploadattachments() {
      var url = "";
      if (this.editId) url = "/categorytype/upload/icon/" + this.editId;
      else url = "/categorytype/upload/icon/" + this.scId;
      this.categoryImg = null;
      axios({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },

        data: this.attachmentsformData,
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          //this.appLoading = true;
          // vm.uploadMsg = "Uploading " + percentCompleted + "%";
          if (percentCompleted == 100) {
            // this.appLoading = false;
          }
        },
      })
        .then((response) => {
          if (response.status) {
            this.appLoading = false;
            this.attachmentsformData = new FormData();
            this.getcatType();
            this.editId = null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    rowClicked(item) {
      this.$router.push("/category/" + item._id);
    },
  },
};
</script>
<style >
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>



